// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, FreeMode, EffectFade, Controller } from 'swiper/modules';

function basicSlider(){
	const slider = new Swiper('[data-name="basic-slider"]', {
		modules: [Pagination, Autoplay],
		loop: true,
		draggable: true,
		allowTouchMove: true,
		effect: 'slide',
		spaceBetween: 20,
		slidesPerView: 1,

		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',  // bullets, fraction (ex. 1/10), progressbar
			clickable: true,
		},
	});
}

function basicSliderFade(){
	const slider = new Swiper('[data-name="basic-slider-fade"]', {
		modules: [Pagination, Autoplay, EffectFade],
		loop: true,
		draggable: true,
		allowTouchMove: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		spaceBetween: 20,
		slidesPerView: 1,
		/* autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		}, */

		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',  // bullets, fraction (ex. 1/10), progressbar
			clickable: true,
		},
	});
}

function overflowSlider(){
	var swiper = new Swiper('[data-name="overflow-slider"]', {
		modules: [Navigation, Autoplay, FreeMode],
		slidesPerView: 1,
		spaceBetween: 30,
		freeMode: true,
		autoplay: false,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},

		breakpoints: {
			768: {
				slidesPerView: 2,
			},
		}
	});
}

function doubleSlider(){
	var swiper = new Swiper('[data-name="double-slider"]', {
		modules: [Navigation, EffectFade, Autoplay],
		slidesPerView: 1,
		spaceBetween: 30,
		//autoplay: false,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
	});
}


function syncSlider(){
	var sliderOne = new Swiper('[data-name="basic-slider-sync-1"]', {
		modules: [Pagination, Autoplay, Controller],
		loop: true,
		slidesPerView: 1,
		spaceBetween: 0,
		effect: 'slide',
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',  // bullets, fraction (ex. 1/10), progressbar
			clickable: true,
		},
	});
	
	var sliderTwo = new Swiper('[data-name="basic-slider-sync-2"]', {
		modules: [Autoplay, EffectFade, Controller],
		loop: true,
		slidesPerView: 1,
		spaceBetween: 0,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
	});
	
	sliderTwo.controller.control = sliderOne;
	sliderOne.controller.control = sliderTwo;
}

export { basicSlider, basicSliderFade, overflowSlider, doubleSlider, syncSlider };